<template>
  <div>
    <register-progress :step="1"/>
    <register-form />
  </div>
</template>

<script>
import RegisterForm from '@/sim-plus/components/Register/Form'
import RegisterProgress from '@/sim-plus/components/Register/Progress'

export default {
  name: 'RegisterPhotoVerifyView',
  components: {
    RegisterProgress,
    RegisterForm
  }
}
</script>
